import React, { useState } from 'react';
import { FiMail, FiPhone, FiLinkedin, FiGithub, FiEdit3, FiFacebook } from 'react-icons/fi';
import { FaDev, FaHashnode } from 'react-icons/fa6';
import './Contact.css';

const Contact = () => {
  const [btnText, setBtnText] = useState('Send Message →');
  const [btnBg, setBtnBg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBtnText('Sending...');

    const formData = new FormData(e.target);
    formData.append("access_key", "d6c09eee-5954-4049-9cd8-18e22ea09b87");

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: json
      });
      const result = await res.json();

      if (result.success) {
        setBtnText('Message Sent ✓');
        setBtnBg('#00A854');
        e.target.reset();
      } else {
        setBtnText('Failed to Send');
        setBtnBg('#FF3B30');
      }
    } catch (error) {
      setBtnText('Failed to Send');
      setBtnBg('#FF3B30');
    }

    setTimeout(() => {
      setBtnText('Send Message →');
      setBtnBg('');
    }, 3500);
  };

  return (
    <section id="contact">
      <div className="sec-inner">
        <div className="sec-label">07 — Contact</div>
        <h2 className="sec-title">Let's build<br /><em>something real</em></h2>
        <div className="contact-layout">
          <div>
            <p className="contact-text">Open to full-time roles, remote opportunities, and collaborations in full stack development, backend engineering, or medical AI research. I respond fast.</p>
            <ul className="contact-list">
              <li className="c-item"><span className="c-icon"><FiMail size={16} /></span><a href="mailto:bijonbijosilin@gmail.com">bijonbijosilin@gmail.com</a></li>
              <li className="c-item"><span className="c-icon"><FiPhone size={16} /></span><a href="tel:+94773155125">+94 773 155 125</a></li>
              <li className="c-item"><span className="c-icon"><FiLinkedin size={16} /></span><a href="https://linkedin.com/in/marisilin-bijosilin" target="_blank" rel="noopener noreferrer">linkedin.com/in/marisilin-bijosilin</a></li>
              <li className="c-item"><span className="c-icon"><FiGithub size={16} /></span><a href="https://github.com/Bijon2002" target="_blank" rel="noopener noreferrer">github.com/Bijon2002</a></li>
              <li className="c-item"><span className="c-icon"><FiFacebook size={16} /></span><a href="https://www.facebook.com/bijon.bijosiilin/" target="_blank" rel="noopener noreferrer">facebook.com/bijon.bijosiilin</a></li>
              <li className="c-item"><span className="c-icon"><FiEdit3 size={16} /></span><a href="https://medium.com/@Bijonn" target="_blank" rel="noopener noreferrer">medium.com/@Bijonn</a></li>
              <li className="c-item"><span className="c-icon"><FaDev size={16} /></span><a href="https://dev.to/bijon_" target="_blank" rel="noopener noreferrer">dev.to/bijon_</a></li>
              <li className="c-item"><span className="c-icon"><FaHashnode size={16} /></span><a href="https://hashnode.com/@bijon" target="_blank" rel="noopener noreferrer">hashnode.com/@bijon</a></li>
            </ul>
          </div>
          <div>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="f-group">
                  <label className="f-label">Name</label>
                  <input type="text" name="name" className="f-input" placeholder="Your name" required />
                </div>
                <div className="f-group">
                  <label className="f-label">Email</label>
                  <input type="email" name="email" className="f-input" placeholder="you@company.com" required />
                </div>
              </div>
              <div className="f-group full">
                <label className="f-label">Message</label>
                <textarea name="message" className="f-input" placeholder="Tell me about the role or project..." required></textarea>
              </div>
              <button type="submit" className="f-submit" style={btnBg ? { background: btnBg } : undefined}>{btnText}</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
